import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 合併受入資産 */
enum AcquiredMerger {
  mergedAssets = '1',
  other = '2',
}

const nameConfig = {
  mergedAssets: new Map([
    [Locale.ja, '合併受入'],
    [Locale.en, 'Acquired by Merger'],
  ]),
  other: new Map([
    [Locale.ja, 'その他'],
    [Locale.en, 'Other'],
  ]),
};

const toEnum = rawValueToEnum(AcquiredMerger, AcquiredMerger.mergedAssets);
const toDisplay = enumToName(AcquiredMerger, nameConfig);
const toDisplayWithPrefix = enumToName(AcquiredMerger, nameConfig, { prefix: true });

export const acquiredMerger = {
  enum: AcquiredMerger,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AcquiredMerger };
